import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { __ } from '../../Lang.js';

const PlaylistModal = ({ videoId, onClose, onResult }) => {
  const [playlists, setPlaylists] = useState([]);
  const [selectedPlaylistId, setSelectedPlaylistId] = useState('');
  const [newPlaylistTitle, setNewPlaylistTitle] = useState('');

  useEffect(() => {
    fetch('/api/v2/twi/mylists', { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      // RESTful index returns the GroupResponseContract shape: { status, group: [...] }
      .then((data) => setPlaylists(Array.isArray(data?.group) ? data.group : []))
      .catch((err) => console.error('Error loading playlists:', err));
  }, []);



const handleSubmit = async () => {
  if (!videoId) return;

  try {
    let response;
    if (selectedPlaylistId === 'new') {
      if (!newPlaylistTitle.trim()) return;
      // Create via the catch-all POST (creates + returns the new uniqid).
      response = await fetch(`/api/v2/twi/mylist?playlist_name=${encodeURIComponent(newPlaylistTitle)}&asset_id=${videoId}`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });
    } else {
      // Add to an existing playlist by uniqid (never numeric playlist_id).
      response = await fetch(`/api/v2/twi/mylist/${encodeURIComponent(selectedPlaylistId)}/video?asset_id=${videoId}`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });
    }

    const data = await response.json();

    if (data.status === 'success') {
      onResult?.('Added to playlist!');
    } else if (data.status === 'already_exists') {
      onResult?.('Already in playlist');
    } else {
      onResult?.('Error adding to playlist');
    }

    onClose();
  } catch (err) {
    console.error('Failed to add to playlist:', err);
    onResult?.(' Network error');
    onClose();
  }
};

  return (
    <div className="playlist-modal">
      <div className="playlist-modal__content">
        <IconButton className="close-button" onClick={onClose} aria-label="Close" sx={{ backgroundColor: '#4B256D', color: 'white', padding: '0.5rem', '&:hover': { backgroundColor: '#3a1d54' } }}>✕</IconButton>
        <h2>{__('My Lists')}</h2>

        <FormControl fullWidth sx={{ my: '1rem' }}>
          <InputLabel id="playlist-select-label">{__('Add to My List')}</InputLabel>
          <Select
            labelId="playlist-select-label"
            id="playlist-select"
            value={selectedPlaylistId}
            label={__('Add to My List')}
            onChange={(e) => setSelectedPlaylistId(e.target.value)}
          >
            <MenuItem value="">{__('Select Playlist')}</MenuItem>
            <MenuItem value="new">{__('NEW PLAYLIST')}</MenuItem>
            {playlists.map((pl) => (
              <MenuItem key={pl.uniqid} value={pl.uniqid}>{pl.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedPlaylistId === 'new' && (
          <TextField
            id="new-playlist"
            label={__('Create new Playlist and add selection:')}
            value={newPlaylistTitle}
            onChange={(e) => setNewPlaylistTitle(e.target.value)}
            placeholder={__('New Playlist Name')}
            fullWidth
            sx={{ my: '1rem' }}
          />
        )}

        <Button className="action-button" variant="contained" onClick={handleSubmit} sx={{ backgroundColor: '#4B256D', width: '100%', mt: '1rem', '&:hover': { backgroundColor: '#3a1d54' } }}>{__('Add Selection')}</Button>
      </div>
    </div>
  );
};

export default PlaylistModal;